module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Saiga12_C.5bf73154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Saiga12_C.png
// module id = 243
// module chunks = 0